import * as React from 'react';
import Header from '../../components/header';
import CoursesService, { Course } from '../../services/CoursesService';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { AppRoute } from '../../definitions/routes';

export interface ICoursesProps {  
}

export interface ICoursesState {
  
}

export default class ScenarioCourse extends React.Component<ICoursesProps, ICoursesState> {
  constructor(props: ICoursesProps) {
    super(props);

    this.state = {
      
    }
  }

  async componentDidMount () {
    // let availableCourse = await CoursesService.getAvailable();
    // this.setState({courses: availableCourse});
  }
  
  public render() {
    return (
      <div>
        <Header title="Прохождение курса" />
        <Container>
          <Row>
            <Col md={12}>              
              Курс...
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
